import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouterProps } from '../../utils/with-router-props'

import { fetchApiDataIfNeeded } from '../../../actions/api'
import { apiResourceEndpoint } from '../../../constants/routes'

const mapStateToProps = (state, ownProps) => {
    console.log('what?')
    console.log(ownProps)
    return {
        user: state.user,
        lead: state.leads.find(lead => lead.id === Number(ownProps.params.leadId))
    }
}

const ViewLead = ({ dispatch, params, user, lead }) => {
    const agentId = user?._computed.agentId || null
    const leadId = Number(params.leadId)

    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('leads', 'VIEW', leadId)))
    }, [dispatch, leadId])

    if (!agentId || !lead) {
        return null
    }

    return (
        <div>
            <h2>{lead.tripName}</h2>
            <div className="value-label">
                <span className="label">Organizer</span>
                <span className="value">{lead.organizerFirstName} {lead.organizerLastName}</span>
            </div>
            <div className="value-label">
                <span className="label">Email</span>
                <span className="value"><a href={`mailto:${lead.organizerEmail}`}>{lead.organizerEmail}</a></span>
            </div>
            <div className="value-label">
                <span className="label">Dates</span>
                <span className="value">{lead.departureDate} - {lead.returnDate}</span>
            </div>
            <div className="value-label">
                <span className="label">Trip Length</span>
                <span className="value">{lead.tripLength} days</span>
            </div>
            <div className="value-label">
                <span className="label">Destination</span>
                <span className="value">{lead.destinations || 'N/A'}</span>
            </div>
        </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(ViewLead))
